import { Deserializable } from '../protocols/deserializable';
import { RelationshipStatusSubmissionData } from './relationship-status-submission-data';

export class RelationshipStatusSubmission implements Deserializable {
  public note: string | null = null;
  public previous!: RelationshipStatusSubmissionData | null;
  public new!: RelationshipStatusSubmissionData;

  public onDeserialize() {
    const Deserialize = window.injector.Deserialize;

    if (this.previous) {
      this.previous = Deserialize.instanceOf(RelationshipStatusSubmissionData, this.previous);
    }

    if (this.new) {
      this.new = Deserialize.instanceOf(RelationshipStatusSubmissionData, this.new);
    }
  }
}
